import { apiPersonalData } from "@/api";
import { api } from "@/api";

class COMMON_API {
  static getPersonByCnpj(payload) {
    return apiPersonalData.get(`/v1/pessoa-juridica/${payload}`);
  }

  static getCEP(cep) {
    return apiPersonalData.get(`/v1/cep/${cep}`).catch(() =>
      Promise.reject({
        response: {
          data: {
            error_description: "Serviço indisponível no momento."
          }
        }
      })
    );
  }

  static getCNAE(code) {
    return api.get(`/v1/cnaes/suggest?query=${code}`);
  }

  static getUserPermissions() {
    return api.get("/v1/me/acoes");
  }
  static getSubModalities() {
    return api.get("v1/garantia/modalidades/submodalidades");
  }
  static getEconomicGroup(payload) {
    return api.get(`v1/gruposeconomicos/suggest${payload}`);
  }
  static getModalities() {
    return api.get("v1/garantia/modalidades/suggest");
  }
  static getInsuranceCompanies(payload) {
    return api.get("v1/seguradoras/suggest", { params: payload });
  }
  static getCourt(payload) {
    return api.get(`v1/judiciario/tribunais/suggest${payload}`);
  }
  static getQuotation(payload) {
    return api.get(`v1/garantia/cotacoes${payload}`);
  }
  static getQuotationAgro(payload) {
    return api.get(`v1/agro/cotacoes${payload}`);
  }
  static getPropostaAgro(payload) {
    return api.get(`v1/agro/cotacoes/listarpropostas${payload}`);
  }
  static getApoliceAgro(payload) {
    return api.get(`v1/agro/cotacoes/listarapolices${payload}`);
  }
  static getInsured(payload) {
    return api.get(`v1/segurados/cotacao${payload}`);
  }
  static getTaker(payload) {
    return api.get(`v1/gruposeconomicos/tomadores/suggest${payload}`);
  }

  static suggestUsers(filter) {
    return api.get(`/v1/usuarios/suggest${filter}`);
  }

  static suggestCompany({ query, groupId }) {
    return api.get(`/v1/gruposeconomicos/${groupId}/tomadores/suggest`, {
      params: {
        query,
        subsidiarias: false
      }
    });
  }
  static suggestCancelItems(payload) {
    return api.get("/v1/motivoscancelamento/suggest", {
      params: { modalidade_id: payload }
    });
  }
  static suggestOperationalGroups(filter) {
    return api.get(`/v1/gruposoperacao/suggest${filter}`);
  }
  static getStatusQuotation() {
    return api.get("/v1/garantia/cotacoes/status/suggest");
  }
  static getStatusPolicy() {
    return api.get("/v1/garantia/apolices/situacao/suggest");
  }
  static getPolicy(payload) {
    return api.get(`v1/garantia/apolices${payload}`);
  }
  static getTypesEndorsement() {
    return api.get("/v1/garantia/apolices/endossos/tipos/suggest");
  }
  static getStatusEndorsement() {
    return api.get(
      "v1/garantia/apolices/endossos/solicitacao/situacao/suggest"
    );
  }
}

export default COMMON_API;
